module.exports = __webpack_public_path__ + "static/GT-Super-Display-Light-618a4a9337b407ecbd0886a908394faf.woff2";